<template>
	<div>
		<cTable ref="table" :config="config" :fields="fields" :footer="{show:()=>false}"></cTable>
	</div>
</template>

<script>
	import cTable from "@/base/common/index";
	export default {
		components: {
			cTable
		},
		props:{
			read:{
				type:Boolean,
				default:false
			},
			list:{
				type:Array,
				default:()=>[]
			}
		},
		mounted(){
			
			setTimeout(()=>{
				this.$nextTick(()=>{
					if(this.$refs['table'])this.$refs['table'].list = this.list
				})
			},1000)
		},
		data() {
			return {
				config:{
					slot:'div',
					height:160,
					resize:false
				},
				fields:[
					{
						name: () => this.$t('packingNum'),
						placeholder:()=>this.$t("packingNum"),
						key: "boxes_number",
						minWidth: 130,
						component:!this.read&&'Input'
					},
					{
						name: () => 'Sku '+this.$t("noofpieces"),
						placeholder:()=>'Sku '+this.$t("noofpieces"),
						key: "sku_number",
						minWidth: 130,
						component:!this.read&&'Input'
					},
					{
					  type: "btns",
					  width: 160,
					  name: () => this.$t("operation"),
					  fixed: "right",
					  // width({ field }) {
					  //   return field.list.length * 40 + 40;
					  // },
					  list: [
					    {
					      name: () => this.$t("add"),
					      type: "add",
					      fnName: "add",
					      bind: {
					        type: "warning",
					      },
					      icon: "md-add",
								show:()=>{
									return !this.read
								},
					    },
					    {
					      name: () => this.$t("delete"),
					      type: "delete",
					      fnName: "delete",
					      icon: "md-trash",
								show:()=>{
									return !this.read
								},
					    },
					  ],
					  methods: {
					    add({ row,rowIndex }) {
								this.list.splice(rowIndex,0,{
								  boxes_number:'',
								  sku_number:'',
								})
					    },
					    delete({ row,rowIndex }) {
								this.list.splice(rowIndex,1)
								if(!this.list.length)this.list.push({
									boxes_number:'',
									sku_number:'',
								})
					    },
					  },
					},
				]
			}
		},
	}
</script>

<style scoped>

</style>